import * as React from 'react';
import { Stack, Typography, IconButton, Select, MenuItem } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

type Props = {
  page: number;           // 1-based
  totalPages: number;
  from: number;           // e.g., 1
  to: number;             // e.g., 25
  total: number;          // e.g., 30
  onPrev: () => void;
  onNext: () => void;
  onSelectPage: (page: number) => void;
};

export default function PaginationBar({
                                        page,
                                        totalPages,
                                        from,
                                        to,
                                        total,
                                        onPrev,
                                        onNext,
                                        onSelectPage,
                                      }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} justifyContent="flex-end" sx={{ px: 1 }}>
      <Typography variant="body2">
        {from}-{to} of {total}
      </Typography>

      <Select
        size="small"
        value={page}
        onChange={(e) => onSelectPage(Number(e.target.value))}
        sx={{ mx: 0.5 }}
      >
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
          <MenuItem key={p} value={p}>{p}</MenuItem>
        ))}
      </Select>

      <Typography variant="body2">of {totalPages} pages</Typography>

      <IconButton onClick={onPrev} disabled={page <= 1} size="small">
        <NavigateBeforeIcon />
      </IconButton>
      <IconButton onClick={onNext} disabled={page >= totalPages} size="small">
        <NavigateNextIcon />
      </IconButton>
    </Stack>
  );
}
